export default __webpack_public_path__ + "static/media/Ballroll_00175.5827b558.png";